import clearFilter from '../modules/productListClearFilter';
import openFilter from '../modules/productListOpenFilter';
import toggleFilter from '../modules/productListToggleFilter';
import filter from '../modules/productListFilter';

clearFilter();
openFilter();
toggleFilter();
filter();

